import {Injectable} from '@angular/core';
import {Platform} from '@ionic/angular';
import {AppPlatform} from '../DataModels/AppVersion';

@Injectable({
  providedIn: 'root'
})
export class PlatformHelperService {

  private readonly _isMobile: boolean;
  public get isMobile(): boolean { return this._isMobile; }
  private readonly _isWeb: boolean;
  public get isWeb(): boolean { return this._isWeb; }
  private readonly _isAndroid: boolean;
  public get isAndroid(): boolean { return this._isAndroid; }
  private readonly _isIOS: boolean;
  public get isIOS(): boolean { return this._isIOS; }
  public get appPlatform(): AppPlatform | undefined {
    if (this.isAndroid) { return AppPlatform.Android; }
    return AppPlatform.iOS;
  }

  constructor(private platform: Platform) {
    if (this.platform.is('capacitor')) {
      this._isMobile = true;
    } else {
      this._isWeb = true;
    }
    if (this.platform.is('android')) {
      this._isAndroid = true;
    }
    if (this.platform.is('ios')) {
      this._isIOS = true;
    }
  }
}
